import { render, staticRenderFns } from "./MapIconClinic.vue?vue&type=template&id=5879c3a6&scoped=true&"
import script from "./MapIconClinic.vue?vue&type=script&lang=js&"
export * from "./MapIconClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5879c3a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5879c3a6')) {
      api.createRecord('5879c3a6', component.options)
    } else {
      api.reload('5879c3a6', component.options)
    }
    module.hot.accept("./MapIconClinic.vue?vue&type=template&id=5879c3a6&scoped=true&", function () {
      api.rerender('5879c3a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/icons/MapIconClinic.vue"
export default component.exports